import React from "react";
import denfit from "../../assets/equipments/denfit/denfit-1.png";
import hags from "../../assets/hags.png";
import denfitLogo from "../../assets/denfit-logo.png";
import ProductCard from "../ProductCard";
import { useTranslation } from "react-i18next";

const EshopOutdoorSport = () => {
  const { t } = useTranslation();
  const outdoorsportData = [
    {
      img: denfit,
      title: t("eshop.equipment_product_title1"),
      desc: t("eshop.equipment_product_outdoorsport_desc1"),
      path: "/el-parduotuve/lauko-sportas",
      partners: [
        { logo: hags, path: "https://www.hags.com/home" },
        { logo: denfitLogo, path: "https://denfit.nl" },
      ],
    },
  ];
  return (
    <section className="relative w-full h-full">
      <div className="w-full px-[5%]">
        <div className="pt-12 pb-16 maxContainer">
          <h2 className="mb-4 text-sm font-bold ss:text-md ">
            {t("products.explore_outdoor_sports_heading")}
          </h2>
          <p className="mb-12 text-greyText">
            {t("products.explore_outdoor_sports_desc")}
          </p>

          <div className="grid justify-between grid-cols-1 gap-10 ss:gap-5 md:gap-12 ss:grid-cols-2">
            {outdoorsportData.map((card, index) => (
              <ProductCard key={index} {...card} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EshopOutdoorSport;
